var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fix-sidebar"},[_c('div',[_c('div',[_c('Header'),_vm._v(" "),_c('Sidebar'),_vm._v(" "),_c('div',{staticClass:"page-wrapper"},[_c('upperHeader'),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('router-view')],1),_vm._v(" "),_c('Footer',{staticClass:"footer"})],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-513f4777","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/main.vue
// module id = null
// module chunks = 